export class IntersectionObserverComponent {
    static $inject = ['$element'];

    intersecting = false;

    width?: string;
    height?: string;

    private observer!: IntersectionObserver;

    constructor(private $element: ng.IRootElementService) {}

    style = {};

    $onInit() {
        this.observer = new IntersectionObserver((c) => {
            if (c[0].isIntersecting) {
                this.intersecting = true;

                // clear any styles
                this.style = {};
            }
        });
        this.observer.observe(this.$element[0]);

        const { width, height } = this;
        this.style = {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            ...(width && { width }),
            ...(height && { height }),
        };
    }

    $onDestroy() {
        this.observer.disconnect();
    }
}

angular.module('tradersyard').component('tyIntersectionObserver', {
    // language=HTML
    template: `
        <div ng-style="$ctrl.style">
            <ty-loading-spinner ng-if="!$ctrl.intersecting"/>
            <ng-transclude ng-if="$ctrl.intersecting"></ng-transclude>
        </div>
    `,
    controller: IntersectionObserverComponent,
    transclude: true,
    bindings: {
        width: '@',
        height: '@',
    },
});
